import React, { Fragment } from 'react';
import formatCurrencyService from '../Services/formatCurrencyService';

const ProductPrice = ({ campaignPrice, price, packagingQuantity, formatter, quantity }) => (
    <div className="accessory-list__prices-container">
        {campaignPrice != 0 && campaignPrice < price &&
            <Fragment>
                {quantity === 0 ?
                    (
                        <span className="accessory-list__originalprice">{formatCurrencyService.formatCurrency(formatter, price * packagingQuantity)}</span>
                    ) : (
                        <span className="accessory-list__originalprice">{formatCurrencyService.formatCurrency(formatter, price * quantity)}</span>
                    )
                }
            </Fragment>
        }
        {quantity === 0 ?
            (
                <span className="accessory-list__price">
                    {formatCurrencyService.formatCurrency(formatter, (campaignPrice != 0 && campaignPrice < price ? campaignPrice : price) * packagingQuantity)}
                </span>
            ) : (
                <span className="accessory-list__price">
                    {formatCurrencyService.formatCurrency(formatter, (campaignPrice != 0 && campaignPrice < price ? campaignPrice : price) * quantity)}
                </span>
            )
        }
    </div>
)


export default ProductPrice;